import Heading from './Heading.js'
import UserList from './UserList.js'

const Home = () => {
    return (
        <>
            <Heading />
            <UserList />
        </>
    )
}

export default Home
